<template>
  <div class="myHecoosLight_wrap english_container">
    <myHeader />
    <!-- banner模块 -->
    <div class="banner">
      <p style="font-weight: 900;margin-bottom: 20px;" class="wow fadeInUp fami">hecoos Lighting</p>
      <p style="margin-top: 10px;font-weight: 400;" class="wow fadeInUp enTwoProductDesc">
        Combines lighting design programming with<br />
        fixture control in one system
      </p>

      <router-link
        id="hecoos_lighting_contact_us"
        class="callMe"
        :to="{ name: 'enCaseDemonstration', hash: '#specific-position' }"
        >Contact Us</router-link
      >
    </div>

    <!-- 产品模块 -->
    <div class="product colorBlack">
      <div class="tab">
        <p class="enProductTitle wow fadeInUp" style="margin-bottom: 0px">
          Overview
        </p>
        <p class="wow fadeInUp enProductTitle">Core Features</p>
        <div class="switch" ref="switch_list">
          <!-- 为每个 span 绑定点击事件和动态类名 -->
          <span
            :class="{ select: currentTabIndex === 0 }"
            @click="selectTab(0)"
          >
            Design Verification
          </span>
          <span
            :class="{ select: currentTabIndex === 1 }"
            @click="selectTab(1)"
          >
            Precision
          </span>
          <span
            :class="{ select: currentTabIndex === 2 }"
            @click="selectTab(2)"
          >
            Flexible tuning
          </span>
          <span
            :class="{ select: currentTabIndex === 3 }"
            @click="selectTab(3)"
          >
            Compatibility and Integration
          </span>
          <div
            class="underline"
            :style="{
              width: underlineWidth + 'px',
              left: underlineLeft + 'px',
            }"
          ></div>
        </div>
      </div>
      <!-- 产品内容部分 -->
      <div>
        <div class="content flexContent">
          <div class="studio" v-show="showContents[0]">
            <img
              src="https://download.hecoos.com/enlightv/2025-35/2280bde9991ca621fe9d1af4cbdef6b3.jpg"
              alt=""
              class="wow fadeInUp"
            />
            <p class="textContent wow fadeInUp">
              The lighting design project involves working with real lighting
              fixtures to create "practical, implementable designs.”
            </p>
          </div>
          <div class="studio" v-show="showContents[1]">
            <img
              src="https://download.hecoos.com/enlightv/2025-35/31a937f43af23b7bfd64e0963456b0d9.jpg"
              alt=""
            />
            <p class="textContent">
              Built-in "universal lighting fixtures," allowing for the
              independent editing of lighting library files and assignment of
              address codes, as well as previewing the effects of various types
              of lighting fixtures.
            </p>
          </div>
          <div class="studio" v-show="showContents[2]">
            <img
              src="https://download.hecoos.com/enlightv/2025-35/dd4320bc34627fe4fe050a9c1ad7020c.jpg"
              alt=""
            />
            <p class="textContent">
              Quickly adjust the design plan without having to wait for the
              "next report.
            </p>
          </div>
          <div class="studio" v-show="showContents[3]">
            <img
              src="https://download.hecoos.com/enlightv/2025-35/39622fe1143bbb20cd3f46fd67e5e308.jpg"
              alt=""
            />
            <div class="textContent">
              <p>
                Through the integration of control protocols such as DMX512 and
                Art-Net, hecoos has full control over stage lighting fixtures,
                film lighting fixtures, LED light strips, and other lighting
                equipment.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 应用场景模块 -->
    <div class="application">
      <p
        style="font-size: 70px; font-weight: 700; margin-bottom: 45px"
        class="wow fadeInUp enProductTitle"
      >
        Application Scenario
      </p>
      <p style="color: #b8b8b8; font-size: 24px" class="wow fadeInUp">
        Practical use of hecoos Lighting
      </p>
      <myBanner
        :applicationInfo="applicationInfo"
        class="wow fadeInUp"
      ></myBanner>
    </div>
    <Creativity :imgUrl="imgUrl"></Creativity>
    <!-- <myText></myText> -->
    <myFooter></myFooter>
    <BackToTop />
  </div>
</template>

<script>
import myHeader from "@/components/en_pc/myHeader.vue";
import myFooter from "@/components/en_pc/myFooter.vue";
import Creativity from "@/components/en_pc/creativity";
// import myText from "@/components/en_pc/myText";
import myBanner from "@/components/en_pc/myBanner";
import BackToTop from "@/components/en_pc/BackToTop";

export default {
  data() {
    return {
      imgUrl:
        "https://download.hecoos.com/enlightv/2025-17/15ee7aebaec0c2d6bb4d5437a737c89d.png",
      underlineWidth: 0,
      underlineLeft: 0,
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 0,
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false, false, false],
      applicationInfo: [
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/4c26cceb192db0e870b3e3f5a6e7f244.png",
          title: "Media Facade",
          msg: "hecoos enables pixel-level planning for architectural lighting, transforming building facades into animated canvases where each luminaire becomes a display primitive.",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/fa2f7a7824868e8c7944470ce5aeb046.png",
          title: "Stage Performance",
          msg: `hecoos visualizes lighting designs in pre-production, then executes frame-accurate timeline synchronization for live performances – embodying the product philosophy: Design Manifested.`,
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/573c939ef903eb22889b1ce5f8bbcf73.png",
          title: "Art Installation",
          msg: "hecoos delivers unified control over multi-brand professional luminaires, translating multi-protocol signals to achieve intact creative translation across lighting rigs. This empowers artists to realize complex visions with enhanced operational fluency and technical reliability.",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/ad08dc41bd6095fde80ba3fcbb180d2d.png",
          title: "Virtual Shooting",
          msg: "hecoos syncs virtual and physical lighting in real time, perfectly replicating onsite conditions.",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/e1129dc83d3b32b7781399479293a189.png",
          title: "Theme Park",
          msg: "hecoos automates thematic scene choreography and sustains 24/7 lighting cycles, delivering operational resilience that simplifies park maintenance.",
        },
        {
          imgUrl:
            "https://download.hecoos.com/enlightv/2025-17/2edfed4893177c6691056fec5d75eb72.png",
          title: "Brand Event",
          msg: "hecoos pre-programs entire lightshow sequences, enabling show-ready execution with only minor cue-level adjustments – significantly slashing onsite debugging while delivering design-perfect outputs.",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      window.addEventListener("resize", this.updateUnderlinePosition);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateUnderlinePosition);
  },
  methods: {
    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      this.currentTabIndex = index;
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      this.updateUnderlinePosition();
    },
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },
  },
  components: {
    myHeader,
    myFooter,
    Creativity,
    // myText,
    myBanner,
    BackToTop,
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/en_pc/xty.scss";
@import "@/styles/optimize_adaptation.scss";
.fami {
  font-size: 80px;
}
.enTwoProductDesc {
  font-weight: 500;
}
.underline {
  position: absolute;
  bottom: 0;
  height: 3px;
  background-color: #2a82e4;
  transition: all 0.3s ease;
}
.switch {
  position: relative;
}

.callMe {
  display: inline-block;
  text-decoration: none;
  padding: 16px 24px;
  line-height: 32px;
  border-radius: 40px;
  background-color: #147cf5;
  margin: 0 auto;
  margin-top: 100px;
  font-size: 22px;
  cursor: pointer;
  color: #fff;
  transition: all 0.3s ease;
}

.callMe:hover {
  transform: scale(1.05);
  background-color: #fff;
  color: #147cf5;
}
</style>
